import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { IPublicClientApplication } from '@azure/msal-browser';

/**
 * Gets the current user's claims from MSAL account
 */
function getUserClaims(msalInstance: IPublicClientApplication): Record<string, any> {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
        return {};
    }

    return (accounts[0].idTokenClaims || {}) as Record<string, any>;
}

/**
 * Checks if user has a specific claim
 */
function hasUserClaim(msalInstance: IPublicClientApplication, claimName: string): boolean {
    const claims = getUserClaims(msalInstance);
    const claimValue = claims[claimName];
    return claimValue === true || claimValue === 'true';
}

/**
 * Factory function that creates a route loader requiring a specific claim
 * @param msalInstance The MSAL instance to check claims against
 * @param claimName The claim name to check
 */
export function createRequireClaimLoader(msalInstance: IPublicClientApplication, claimName: string) {
    return ({ request }: LoaderFunctionArgs) => {
        if (!hasUserClaim(msalInstance, claimName)) {
            const params = new URLSearchParams();
            params.set('error', 'insufficient_permissions');
            return redirect(`/?${params.toString()}`);
        }
        return null;
    };
}
